import React from 'react';
import { WebLayout } from '../../Components/WebLayout';
import './style.css';

export const ComingSoon = ({ title }) => {
  return (
    <WebLayout>
      <div className="coming-soon-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 text-center">
              <h1>{title}</h1>
              <p>Coming Soon</p>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};
